module.exports = __webpack_public_path__ + "img/emoji_56.bc7549a5.png";